<template>
    <modal id="schedule-information-modal">
        <template slot="title">
            {{ course.title }}
        </template>
        <template slot="body">
            <div class="content">
                <div class="image" v-if="course.image">
                    <img class="w-100" :src="course.image" :alt="course.title">
                </div>
                <div class="information">
                    <div v-text="shortDateTime(schedule.date)"></div>
                    <div v-text="schedule.instructor.full_name"></div>
                    <div v-text="`${schedule.available_seats} Spaces`"></div>
                </div>
            </div>
        </template>
        <template slot="footer">
            <a :href="`${this.course.public_path}?schedule=${schedule.id}`" class="btn-app-blue">Details</a>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            schedule: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                course: this.schedule.schedulable,
            }
        },

        watch: {
            schedule() {
                this.course = this.schedule.schedulable;
            }
        }
    }
</script>
